export const enUS = {
    home: "HOME",
    intro:"INTRODUCTION",
    visa:"VISA",
    act:"ACTIVITIES",
    contact:"CONTACT",
    language:"中文",
    part1: {
        title: "ABOUT US",
        content: "Element was established in 2001 to meet a growing need for professional migration services for both organisations as well as individuals. With over 18 years’ experience, we specialise in professional migration and recruitment services and take pride in our high success rates and our outstanding service to our customers. As a registered migration agent in Melbourne, our staff are highly experienced and skilled migration agents who can assist with all of your migration and recruitment needs. We work with clients ranging from standard migration, as well as highly complex migrations, often acting as professional migration consultants appointed for many Australian businesses. Based on the consistently high success rates, in 2013, the CEO Ms Grace Xie was certified as a Fellow of the Migration Institute of Australia (FMIA). Grace is also a registered advisor with the Immigration Advisory Authority in New Zealand."
    },
    part2: {
        title1:"ESTABLISHED FOR 18 YEARS",
        content1:"Element was established in 2001, since then we have provided migration and recruitment services for over a thousand successful clients.",
        title2:"REGISTERED MIGRATION AGENTS",
        content2:"Element has multiple staff registered as Australian migration agents. Our founder, Grace Xie, was even recognised as a Fellow of the Migration Institute of Australia (FMIA) which is awarded only to the top 20 migration agents in Australia.",
        title3:"VERY HIGH SUCCESS RATES",
        content3:"We have consistently exceeded the industry average with an impressive 96% overall success rate. Contact us today to see how we can help you too!"
    },
    part3: {
        title:"WHY CHOOSE Element?",
        content1:"Apart from out high success rate which is unparalled in the industry, we provide our clients with the high level of service, including the following:",
        content2:"Specialised in Employer Nomination Migration and Business Migration",
        content3:"Sound relationship with Australian state governments",
        content4:"Ability to obtain state government sponsorship within short period",
        content5:"Ability to provide business and management consulting services to Australian businesses",
        content6:"Professional business background with employer resources from different specialties",
        content7:"Experienced in finding employment opportunities for overseas nurses",
        content8:"Complete financial and legal support",
        content9:"At Element, we believe our service doesn’t stop at just obtaining the visa. We pride ourselves on offering a complete solution for our clients through ongoing support, helping you become integrated in Melbourne’s social community.",
    },
    part4: {
        title:"SERVICES",
        content: "AMRC provides migration services for a full range of visa requirements. Please click on the links below to see more information.",
        part1:{
            title: "BUSINESS MIGRATION",
            content1: '188A Business Innovation Stream ',
            content2: '188B Investor Stream',
            content3: '188C AUD$5 Million Significant Investor Visa',
            content4: '132 Business Talent Visa'
        },
        part2:{
            title: "EMPLOYER NOMINATION",
            content1: '186 Employer Nomination Scheme',
            content2: "482 Temporary Skill Shortage Visa"
        },
        part3:{
            title: "SKILLED MIGRATION",
            content1: '189 Skilled Independent Visa',
            content2: "190 Skilled Nominated visa"
        },
        part4:{
            title: "REGIONAL SKILLED MIGRATION",
            content1: '491 Skilled Work Regional Visa',
            content2: '494 Skilled Employer Sponsored Regional Visa',
            content3: '191 Permanent Residence Visa',
        },
        part5:{
            title: "FAMILY MIGRATION",
            content1: 'Partner Visa',
            content2: "Parent Visa"
        },
        part6:{
            title: "OTHER MIGRATION",
            content1: 'Student Visa',
            content2: 'Family Visitor Visa',
            content3: 'Business Visitor Visa',
        }
    },
    part5:{
        title: "Contact",
        content1:"Address",
        content2:"Phone",
        content3:"Email",
    },
    189:{
        title:"189 Skilled Independent Visa",
        content1:"You can apply for this visa when you are in Australia (onshore) or outside Australia (offshore). This visa is a combination of previous subclass 175 visa and subclass 885 visa. This is a permanent residency visa.",
        content2:`Submit an Expression of Interest
        Be invited to apply for a visa
        Be less than 50 years of age when the invitation is issued
        Nominate an occupation that matches your skills and qualifications and is on the relevant skilled occupation list
        Have your skills assessed by the relevant assessing authority as suitable for your nominated occupation
        Meet the English language requirements
        Be able to score at least 60 on the points test
        Meet the health and character requirements`
    },
    190:{
        title:"190 Skilled Nominated visa",
        content1:"You can apply for this visa when you are in Australia (onshore) or outside Australia (offshore). This visa is a combination of previous subclass 176 visa and subclass 886 visa. This is a permanent residency visa.",
        content2:`Different with Subclass 189 visa, Subclass 190 visa requires you to have a state government sponsorship. The successful visa applicant will need to live in the state for two years before relocating to other states.`
    },
    491:{
        title:"491 Skilled Work Regional (Provisional) Visa",
        content1:`A visa for skilled people nominated by a state or territory government to live and work in regional Australia.
                stay in Australia for 5 years
                live, work and study in a designated regional area of Australia
                travel to and from Australia as many times as you want, while the visa is valid`,
        content2:`Be under 45 years’ old when you submit the EOI
        the position of the main applicant is on the eligible skill occupation list
        have a suitable skills assessment
        be able to score 65 points or more
        have functional English
        be nominated by the state /territory or sponsored by relatives`
    },
    494:{
        title:"494 Skilled Employer Sponsored Regional (Provisional) Visa",
        content1:`This visa enables regional employers to address identified labour shortages within their region by sponsoring skilled workers where employers can’t source an appropriately skilled Australian worker
                You can live, work and study only in designated regional areas of Australia
                You can apply for permanent residence after 3 years from the time your visa is granted`,
        content2:`be under 45 years of age, unless an exemption applies
                be nominated to work in an occupation on the relevant skilled occupation list
                have a relevant skills assessment, unless an exemption applies
                have at least 3 years relevant work experience in your nominated occupation
                have functional English
                work only for your sponsor or associated entity, unless an exemption applies`
    },
    191:{
        title:"191 Permanent Residence (Skilled Regional) Visa",
        content1:`This visa does not commence until 16 November 2022.
                With this visa you can:

                stay permanently
                work and study anywhere in Australia
                Sponsor eligible relatives for permanently residence
                apply for Australian citizenship, if eligible.`,
        content2:`hold a regional provisional visa subclass 491 or 494 visa when they apply for the Subclass 191 visa,
                and have held that visa for at least three years;
                have earned the minimum income for at least three years as the holder of a regional provisional visa; and
                The main applicant and the secondary applicants complied with the conditions of the regional provisional visa.`
    },
    A188:{
        title:"188A Business Innovation Stream",
        content1:" Please contact Element to discuss your suitability in more detail.",
        content2:
            "The provisional Business Innovation and Investment visa is part of the Australian Business Innovation and Investment Program. It is also called Australian Investment Migration, Business Migration, and original subclass 163, 164 migration visas. This type of visa focuses on company turnover and is flexible with investment options."
    },
    B188:{
        title:"188B Investor Stream",
        content1:"Please contact Element to discuss your suitability in more detail.",
        content2:"This visa is for people who want to make a designated investment such as shares, funds or foreign currency in an Australian state or territory. This visa requires the visa applicant to have outstanding investment background and experience. The applicant should be sponsored by an Australian state or territory government and invest in state government bonds for four years before being granted a permanent visa. The applicant is required to reside in Australia for two out of four years before submitting the permanent visa application."
    },
    C188:{
        title:"188C AUD$5 Million Significant Investor Visa",
        content1:"From 24th November 2012, applicants are able to apply for subclass 188 visa under the Significant Investor Stream – AUD$5 million investments. This visa is part of the Australian Business Innovation and Investment Program which appeals successful business people and investors. This visa provides a competitive migration option to high income earners and pushes the development of Australian economy.",
        content2:"The applicant is required to invest at least AUD$5 million into complying investments in Australia for four years."
    },
    132:{
        title:"132 Business Talent Visa",
        content1:"Please contact Element to discuss your suitability in more detail.",
        content2:"The Business Talent visa is part of the Australian Business Innovation and Investment Program, which seeks to expand the country’s economy. This visa is designed for high calibre business people who are owners or part owners of an overseas business and have a genuine and realistic commitment to participate in the management of a new or existing business in Australia. This is a permanent residency visa."
    },
    186:{
        title:"186 Employer Nomination Scheme",
        content1:"This visa is part of the Employer Sponsored Skilled Migration program. It is also known as Employer Sponsored Migration or Employer Nomination Scheme (ENS). Australian government allows onshore Australian companies and/or organisations to employ skilled workers from overseas and sponsor them to live and work in Australia permanently. This is a permanent residency visa.",
        content2:"186 Visa Ranges: Main Australian cities, including Sydney, Melbourne, Brisbane, Gold Coast, New Castle and Wollongong."
    },
    482:{
        title:"482 Temporary Skill Shortage Visa",
        content1:"This visa, referred to as the TSS visa, enables employers to address labour shortages by bringing in genuinely skilled workers where they cannot source an appropriately skilled Australian. It facilitates targeted use of overseas workers to address temporary skill shortages, while ensuring that Australian workers get priority. TSS visa holders can work in Australia in their nominated occupation for their approved sponsor.",
        content2:`The employer becomes an approved sponsor
                The employer nominate the occupation and employee
                The employee applies for a 482 visa`
    },
    couple:{
        title:"Partner Visa",
        content1:"This visa is for people to stay in Australia with their partner, who must be an Australian citizen, Australian permanent resident or eligible New Zealand citizen.",
        content2:"The applicant must be in a genuine and continuing marriage and/or de facto relationship with his/her sponsor. If you apply for this visa based on de facto relationship, you must have been in this relationship for at least 12 months. If you apply for this visa based on prospective marriage (in other words as a fiancé of your sponsor), you must be outside Australia when you are applying for this visa. You must also be engaged with your sponsor and will enter into marriage soon."
    },
    parent:{
        title:"Parent Visa",
        content1:"If you are outside Australia, you may eligible to apply for parent migration under two types of visas: Parent (Migrant) Visa (subclass 103)  and Contributory Parent (Migrant) Visa. Parent (Migrant) Visa (subclass 103) has a waiting period of around 25 years. The applicant of Contributory Parent (Migrant) Visa is required to pay the Australian government relevant fees to support themselves for future medical expenses. The Contributory Parent (Migrant) visa can be divided into two types: Contributory Parent (Migrant) Visa (subclass 143) and Contributory Parent (Temporary) Visa (subclass 173).",
        content2:"The applicant of subclass 143 visa is required to pay for the contributory fees in one installment while the applicant of subclass 173 visa can pay for the contributory amount in separate installments within two years. After paying all the contributory fees, the applicant will be granted with a permanent visa. The contributory amount increases each year."
    },
    student:{
        title:"Student Visa",
        content1:"Element provides student visa services from high school onwards. ",
        content2:"We offer one-stop shop from school selection, career assessment, school application, visa preparation and submission, departure counseling and offshore services."
    },
    visit:{
        title:"Family Visitor Visa",
        content1:"We assist parents of Australian permanent residents or Australian citizens to apply for visitor visa for a period of three to five years. ",
        content2:"This multiple entry visa allows applicants to reside in Australia up to 12 months on each entry."
    },
    business:{
        title:"Business Visitor Visa",
        content1:"We assist companies as well as individuals to apply for Australian business visitor visa. This visa allows you to visit Australia for short-term business purposes, including business-related meetings, seminars, conventions, conferences or networking. ",
        content2:" This visa has maximum validity of three years with each entry no longer than 3 months."
    }
}